



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  }
})
export default class Dropdown extends Vue {
  @Prop() data!: any[];
  @Prop({ default: false }) changeModel!: boolean;
  protected isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  public updateItem(item: any) {
    const data = item.model ? item.model : item;
    this.$emit(`update:model`, data);
    if (this.changeModel) {
      this.$emit("changeSelectedModel", item);
    }
    this.close();
  }
}
